import { useState } from 'react';
import './App.css';

const CONTACT_ICONS = {
  location: (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M12 21s-6-7.75-6-13a6 6 0 0 1 12 0c0 5.25-6 13-6 13z"/>
      <circle cx="12" cy="8" r="2.5"/>
    </svg>
  ),
  phone: (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.29h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  ),
  email: (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="2" y="4" width="20" height="16" rx="2"/>
      <path d="m2 7 10 7 10-7"/>
    </svg>
  ),
  clock: (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="12" cy="12" r="10"/>
      <polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
};

function ContactIcon({ type }) {
  return <span className="contact-icon">{CONTACT_ICONS[type]}</span>;
}

function CornerOrnament({ className }) {
  return (
    <svg
      className={`corner ${className}`}
      viewBox="0 0 110 110"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      aria-hidden="true"
    >
      <path d="M8 8L8 82" stroke="#c9a84c" strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M8 8L82 8" stroke="#c9a84c" strokeWidth="2.5" strokeLinecap="round"/>
      <circle cx="8" cy="8" r="5" fill="#c9a84c"/>
      <path d="M8 26Q26 26 26 8" stroke="#c9a84c" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M8 48Q48 48 48 8" stroke="#c9a84c" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M8 70Q70 70 70 8" stroke="#c9a84c" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
      <circle cx="8" cy="37" r="3" fill="#c9a84c" opacity="0.65"/>
      <circle cx="8" cy="60" r="3" fill="#c9a84c" opacity="0.65"/>
      <circle cx="37" cy="8" r="3" fill="#c9a84c" opacity="0.65"/>
      <circle cx="60" cy="8" r="3" fill="#c9a84c" opacity="0.65"/>
      <ellipse cx="34" cy="34" rx="10" ry="10" fill="#c9a84c" opacity="0.2"/>
      <circle cx="34" cy="34" r="5.5" fill="#c9a84c" opacity="0.55"/>
      <path d="M18 44Q24 36 31 43" stroke="#c9a84c" strokeWidth="1" strokeLinecap="round" opacity="0.55"/>
      <path d="M44 18Q36 24 43 31" stroke="#c9a84c" strokeWidth="1" strokeLinecap="round" opacity="0.55"/>
    </svg>
  );
}

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const links = [
    { label: 'בית', href: '#home' },
    { label: 'אודות', href: '#about' },
    { label: 'רקע מהותי', href: '#background' },
    { label: 'עקרונות', href: '#services' },
    { label: 'צור קשר', href: '#contact' },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <a href="#home" className="navbar-logo">
          <img
            src="/logo.png"
            alt="חיידר קרית מלאכי"
            className="logo-img"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'inline';
            }}
          />
          <span className="logo-text-fallback">חיידר קרית מלאכי</span>
        </a>
        <div className="navbar-end">
          <ul className="navbar-links">
            {links.map((l) => (
              <li key={l.label}>
                <a href={l.href}>{l.label}</a>
              </li>
            ))}
          </ul>
          <a
            href="https://nedar.im/7007877"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-donate"
          >
            תרומה
          </a>
          <button
            className={`nav-burger${menuOpen ? ' is-open' : ''}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label={menuOpen ? 'סגור תפריט' : 'פתח תפריט'}
            aria-expanded={menuOpen}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
      <div className={`mobile-menu${menuOpen ? ' is-open' : ''}`} aria-hidden={!menuOpen}>
        <ul>
          {links.map((l) => (
            <li key={l.label}>
              <a href={l.href} onClick={() => setMenuOpen(false)}>{l.label}</a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

function Hero() {
  return (
    <section id="home" className="hero">
      <CornerOrnament className="corner-tl" />
      <CornerOrnament className="corner-tr" />
      <CornerOrnament className="corner-bl" />
      <CornerOrnament className="corner-br" />

      <div className="hero-body">
        <div className="hero-content">
          <p className="hero-tagline">
            <span className="tagline-line" />
            חיידר קרית מלאכי
            <span className="tagline-line" />
          </p>
          <div className="hero-illustration">
            <img src="/hero-boy.png" alt="תלמיד חיידר לומד" />
          </div>
        </div>
      </div>
    </section>
  );
}

function About() {
  return (
    <section id="about" className="section about">
      <div className="container about-container">
        <h2 className="section-title">אודות החיידר</h2>
        <div className="about-body">
          <div className="about-text-col">
            <p className="about-lead">
              המגדל הגדול "החיידר בקרית מלאכי" בנשיאות מרן ר' שרגא נח שטיינמן שליט"א המקרין אור לכל העיר וסביבותיה<br />
              ומהווה מקום לחינוך טהור הפועל ללא לאות למען טובתם של שלל הילדים הטהורים חורט על דגלו להעמיד נשמות ישראל בדרך ישראל סבא<br />
              ע"פ דעתם עצתם והכוונתם של זקני הדור גדולי ישראל שליט"א
            </p>
            <p className="about-lead">
              כאן המקום לחרוט דבריו של מרנא בעל החפץ חיים זיע"א<br />
              "בכל הדורות היתה ירידת הדורות" - אך במושג "הבל פיהם של תינוקות של בית רבן"
            </p>
            <p className="about-lead">
              <b><u>לא היתה ירידת הדורות!</u></b>
            </p>
            <p className="about-lead">לשותפות בהקמת מקום התורה לחץ כאן</p>
            <a
              href="https://nedar.im/7007877"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary full-width"
            >
              תרומה מאובטחת
            </a>
          </div>
          <div className="about-image-col">
            <img
              src="/stock/c8c83b5361d6d7a217e33c35cb206ad3_fit.png"
              alt="תלמידי החיידר לומדים יחד"
              className="about-photo"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Background() {
  return (
    <section id="background" className="section services">
      <div className="container about-container">
        <h2 className="section-title">רקע מהותי</h2>
        <div className="about-body">
          <div className="about-text-col about-text-col-wide">
            <p className="service-text">
              לפני כעשור, נוצרה קהילה מסורה בקריית מלאכי במטרה להעניק חינוך יהודי טהור. כיום, מוסדנו "חיידר קרית מלאכי" מחזיק כיתות לימוד איכותיות החל מכתה א', המובלות על ידי מחנכים עם חזון ומחויבות לעתיד הדור הבא. תלמידינו היקרים באי החיידר חווים סביבה חינוכית טהורה ותומכת המשלבת מסורת ערכים השקפה עם תוכניות לימוד עשירות ומגוונות.
              בשילוב עזרת הציבור ומתוך שיתוף פעולה, אנו משקיעים את כל המשאבים המזדמנים לידנו לחינוך הטהור של טוב טעם התורה והמצוות.
              אנא ד' הושיעה נא למען תינוקות של בית רבן
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

function StatsStrip() {
  return (
    <section
      className="stats-strip"
      aria-label="נתוני החיידר"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/stock/1067fc9b909404c048283d296c0da3e6_fit.png)`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      {/* פעילות סביב השעון, כיתות מרווחות, 100% חינוך טהור */}
      <div className="stats-strip-inner">
        <div className="strip-stat">
          <span className="strip-number">פעילות</span>
          <span className="strip-label">סביב השעון</span>
        </div>
        <div className="strip-divider" aria-hidden="true" />
        <div className="strip-stat">
          <span className="strip-number">מרווח</span>
          <span className="strip-label">בכיתות הלימוד</span>
        </div>
        <div className="strip-divider" aria-hidden="true" />
        <div className="strip-stat">
          <span className="strip-number">100%</span>
          <span className="strip-label">חינוך טהור</span>
        </div>
      </div>
    </section>
  );
}

const services = [
  {
    numeral: 'א',
    title: 'בראש ובראשונה',
    desc: 'ללכת בדרכי רבותינו שליט"א.',
  },
  {
    numeral: 'ב',
    title: 'תוכניות לימוד מגוונות',
    desc: 'עם אנשי חינוך מקצועיים .',
  },
  {
    numeral: 'ג',
    title: 'שיתוף פעולה עם הורים',
    desc: 'מאבני היסוד - חינוך הוא "שותפות".',
  },
    {
    numeral: 'ד',
    title: 'סביבה תומכת לקידום כל ילד',
    desc: '        באופן פרטני וממוקד לצרכיו האישיים - חנוך לנער.',
  },
];

function Services() {
  return (
    <section id="services" className="section services">
      <div className="container">
        <h2 className="section-title">עקרונות החינוך</h2>
        <div className="services-list">
          {services.map((s) => (
            <div className="service-item" key={s.title}>
              <span className="service-numeral" aria-hidden="true">{s.numeral}</span>
              <div className="service-text">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const WEB3FORMS_ACCESS_KEY = '58b6c619-5c58-4702-8266-017d2416beb1';

function ContactForm() {
  const [fields, setFields] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e) =>
    setFields((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMsg('');

    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          subject: 'פנייה מהאתר',
          from_name: fields.name,
          name: fields.name,
          email: fields.email,
          message: fields.message,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus('success');
      } else {
        setStatus('error');
        setErrorMsg(data.message || 'שליחת ההודעה נכשלה. נסו שוב מאוחר יותר.');
      }
    } catch (err) {
      setStatus('error');
      setErrorMsg('שליחת ההודעה נכשלה. בדקו את החיבור לאינטרנט ונסו שוב.');
    }
  };

  const reset = () => {
    setStatus('idle');
    setErrorMsg('');
    setFields({ name: '', email: '', message: '' });
  };

  if (status === 'success') {
    return (
      <div className="form-success">
        <p className="form-success-title">תודה שפנית אלינו.</p>
        <p className="form-success-sub">ההודעה נשלחה בהצלחה, נחזור אליך בהקדם.</p>
        <button className="btn-outline" onClick={reset}>שלח הודעה נוספת</button>
      </div>
    );
  }

  const sending = status === 'sending';

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <h3 className="form-heading">כתבו לנו</h3>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="cf-name">שם מלא</label>
          <input
            id="cf-name"
            type="text"
            name="name"
            placeholder="שם מלא"
            value={fields.name}
            onChange={handleChange}
            required
            disabled={sending}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="cf-email">דואר אלקטרוני</label>
          <input
            id="cf-email"
            type="email"
            name="email"
            placeholder="כתובת הדואר האלקטרוני שלך"
            value={fields.email}
            onChange={handleChange}
            required
            disabled={sending}
            className="form-input"
          />
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="cf-message">הודעה</label>
        <textarea
          id="cf-message"
          name="message"
          placeholder="הודעה"
          rows="4"
          value={fields.message}
          onChange={handleChange}
          required
          disabled={sending}
          className="form-input form-textarea"
        />
      </div>
      {status === 'error' && (
        <p className="form-error" role="alert">{errorMsg}</p>
      )}
      <button type="submit" className="btn-primary full-width" disabled={sending}>
        {sending ? 'שולח…' : 'שלח'}
      </button>
    </form>
  );
}

function Contact() {
  return (
    <section id="contact" className="section contact">
      <div className="container">
        <h2 className="section-title">צור קשר</h2>
        <p className="section-subtitle">נשמח לשמוע מכם</p>

        <div className="contact-grid">
          <div className="donation-card">
            <h3>פרטי תרומה</h3>
            <p>כל מי שיוכל באמת להיות חלק ממקימי המגדל להאיר לכל העיר כולה - זכות תשב"ר יעמוד לו אלף המגן</p>
            <div className="bank-details">
              <div className="bank-row"><span>בנק</span><span>12</span></div>
              <div className="bank-row"><span>סניף</span><span>648</span></div>
              <div className="bank-row"><span>חשבון</span><span>23739</span></div>
            </div>
            <div className="payment-methods">
              <p className="payment-note">ניתן גם להעביר ב-Bit או העברה בנקאית</p>
              <a
                href="https://nedar.im/7007877"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary full-width"
              >
                תרומה מאובטחת
              </a>
              <a
                href="https://get.tatkm.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-outline full-width donation-alt-btn"
              >
                לתרומה דרך הפורטל שלנו
              </a>
            </div>
          </div>

          <div className="contact-form-card">
            <ContactForm />
          </div>
        </div>

        <div className="contact-info-bar">
          <div className="info-bar-items">
            <div className="info-bar-item">
              <ContactIcon type="location" />
              <span>שדרות בר יהודה 3, קרית מלאכי</span>
            </div>
            <div className="info-bar-sep" aria-hidden="true" />
            <div className="info-bar-item">
              <ContactIcon type="phone" />
              <a href="tel:+97286440221">08-6440221</a>
            </div>
            <div className="info-bar-sep" aria-hidden="true" />
            <div className="info-bar-item">
              <ContactIcon type="email" />
              <a href="mailto:Office@TatKM.org">Office@TatKM.org</a>
            </div>
            <div className="info-bar-sep" aria-hidden="true" />
            <div className="info-bar-item">
              <ContactIcon type="clock" />
              <span>08:15–15:40 | א–ו</span>
            </div>
          </div>
          <div className="info-bar-maps">
            <a
              href="https://maps.google.com/?q=שדרות+בר+יהודה+3,+קרית+מלאכי"
              target="_blank"
              rel="noopener noreferrer"
              className="map-btn google"
            >
              Google Maps
            </a>
            <a
              href="https://waze.com/ul?q=שדרות+בר+יהודה+3,+קרית+מלאכי"
              target="_blank"
              rel="noopener noreferrer"
              className="map-btn waze"
            >
              Waze
            </a>
            <a
              href="https://moovit.com/?to=שדרות+בר+יהודה+3+קרית+מלאכי"
              target="_blank"
              rel="noopener noreferrer"
              className="map-btn moovit"
            >
              Moovit
            </a>
          </div>
        </div>

        <div className="contact-map-wrapper">
          <div className="contact-map">
            <iframe
              title="מיקום החיידר"
              src="https://maps-cdn.cdn-files-a.com/include/globalMapDisplay.php?q=%D7%A9%D7%93%D7%A8%D7%95%D7%AA+%D7%91%D7%A8+%D7%99%D7%94%D7%95%D7%93%D7%94+3%2C+%D7%A7%D7%A8%D7%99%D7%AA+%D7%9E%D7%9C%D7%90%D7%9B%D7%99%2C+%D7%99%D7%A9%D7%A8%D7%90%D7%9C&z=15&l=he&ilfc=1"
              frameBorder="0"
              loading="lazy"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-verse" aria-hidden="true">
        טוֹב לִי תוֹרַת פִּיךָ
      </div>
      <div className="footer-meta">
        <p className="footer-title">קהילת בני תורה קרית מלאכי ע"ר כל הזכויות שמורות</p>
        <p className="footer-operator">מופעל ע"י ע"ר - בני תורה קרית מלאכי - 580623486</p>
        <p className="footer-address">הרב יצחק ניסים 4, קרית מלאכי</p>
      </div>
      <div className="footer-admin">
        <a
          href="https://tatkm.org/Tools.php"
          className="footer-admin-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          התחברות
        </a>
      </div>
    </footer>
  );
}

function App() {
  return (
    <div className="App" dir="rtl">
      <Navbar />
      <Hero />
      <About />
      <Background />
      <StatsStrip />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
